import React from "react";
// ANT DESIGN COMPONENTS
import { Select } from "antd";
// REDUX
import { useSelector } from "react-redux";
// ELEVATOR ICONS ELEVATOR STATUS
// ESCALATOR ICONS STATUS
import esDownDark from "../../../assets/icons/escalator/es-dark-down-4.svg";
import esDownLight from "../../../assets/icons/escalator/es-light-down-4.svg";
import esUpDark from "../../../assets/icons/escalator/es-dark-up-4.svg";
import esUpLight from "../../../assets/icons/escalator/es-light-up-4.svg";
import esStoppedDark from "../../../assets/icons/escalator/es-dark-stopped.svg";
import esStoppedLight from "../../../assets/icons/escalator/es-light-stopped.svg";
// INTERFACES
import { RootState } from "../../../app/store";

export default function SelectIconEscalator({
  setValue,
  value,
}: {
  setValue: (newValue: string) => void;
  value: string;
}) {
  interface IconsInterface {
    id: string;
    name: string;
    icon: string;
  }
  // ************************************************ */
  // USE STATE VARIABLES **************************** */
  const { theme } = useSelector((state: RootState) => state.home);

  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const { Option } = Select;
  const ICONS: IconsInterface[] = [
    {
      id: "esUp",
      name: "Up",
      icon: theme === "dark" || theme === "blue" ? esUpDark : esUpLight,
    },
    {
      id: "esDown",
      name: "Down",
      icon: theme === "dark" || theme === "blue" ? esDownDark : esDownLight,
    },
    {
      id: "esStopped",
      name: "Stopped",
      icon: theme === "dark" || theme === "blue" ? esStoppedDark : esStoppedLight,
    },
  ];

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const onChange = (newValue: string) => {
    setValue(newValue);
  };

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <Select className="generalStyles__width100" size="small" onChange={onChange} value={value}>
      {ICONS.map((item: IconsInterface) => (
        <Option key={item.id} value={item.id}>
          <img src={item.icon} alt={item.name} style={{ height: "20px", width: "20px" }} />{" "}
          {item.name}
        </Option>
      ))}
    </Select>
  );
}
